module.exports = __webpack_public_path__ + "img/mobile-google-play.e3ea015c.svg";